import { useRefreshAccessToken } from './refresh-access-token/hook';
import { useLogin } from './login/hook';
import { useIdMeLogin } from './idme-login/hook';
import { useIdmeRefreshAccessToken } from './idme-refresh-access-token/hook';
import { useAuth0SsoLogin } from './auth0-sso-login/hook';
import { useAuth0SsoRefreshAccessToken } from './auth0-sso-refresh-access-token/hook';

export const Auth = {
  useLogin,
  useIdMeLogin,
  useAuth0SsoLogin,
  useRefreshAccessToken,
  useIdmeRefreshAccessToken,
  useAuth0SsoRefreshAccessToken,
};
